import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import Tooltip from '../Tooltip';
import InfoIcon from '../icons/InfoIcon';

import Collapsible from '../Collapsible';

import CollapsibleIcon from '../icons/CollapsibleIcon';

import styles from './PaymentDetailsCard.module.scss';

const PaymentDetailsCard = ({
  title,
  headerValue,
  headerMeta = null,
  footerText = trans('payment.details.paid.to.landlord'),
  isCollapsed = true,
  dataTest = null,
  children = null
}) => {
  const renderHeaderMeta = () =>
    headerMeta && headerMeta.text ? (
      <div className={styles['payment-details-card__header-meta']}>
        <span>{headerMeta.text}</span>
        {headerMeta.tooltipText ? (
          <Tooltip
            className={styles['payment-details-card__header-meta-tooltip']}
            color="blue-indigo"
            position="bottom"
            tooltip={headerMeta.tooltipText}
          >
            <InfoIcon />
          </Tooltip>
        ) : null}
      </div>
    ) : null;

  const renderHeaderValue = () => (
    <span className={styles['payment-details-card__header-value-amount']}>
      {headerValue}
    </span>
  );

  const renderHeaderBlock = () => (
    <div className={styles['payment-details-card__header-text']}>
      <span className={styles['payment-details-card__title']}>{title}</span>
      <div className={styles['payment-details-card__header-value-wrap']}>
        {renderHeaderValue()}
      </div>
      {renderHeaderMeta()}
    </div>
  );

  const renderBodyInner = () => (
    <div className={styles['payment-details-card__body']}>
      {typeof children === 'function' ? children() : children}
      {footerText ? (
        <span className={styles['payment-details-card__footer']}>
          {footerText}
        </span>
      ) : null}
    </div>
  );

  return (
    <div className={styles['payment-details-card']}>
      <Collapsible
        bodyClassName={styles['payment-details-card__collapsible-body']}
        dataTest={dataTest}
        hasIcon
        headerClassName={styles['payment-details-card__collapsible-header']}
        iconClosed={<CollapsibleIcon collapsed />}
        iconOpened={<CollapsibleIcon collapsed={false} />}
        isCollapsed={isCollapsed}
        renderBody={renderBodyInner}
        renderHeader={renderHeaderBlock}
      />
    </div>
  );
};

const HeaderMetaShape = PropTypes.shape({
  text: PropTypes.string.isRequired,
  tooltipText: PropTypes.string
});

PaymentDetailsCard.propTypes = {
  title: PropTypes.string.isRequired,
  headerValue: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  headerMeta: HeaderMetaShape,
  footerText: PropTypes.string,
  isCollapsed: PropTypes.bool,
  dataTest: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node])
};

export default PaymentDetailsCard;
